module.exports = __webpack_public_path__ + "img/img-77.8fee1d64.png";